export var ExportJobProcessingResult;
(function (ExportJobProcessingResult) {
    ExportJobProcessingResult["StartExport"] = "StartExport";
    ExportJobProcessingResult["SkipTerminalJob"] = "SkipTerminalJob";
})(ExportJobProcessingResult || (ExportJobProcessingResult = {}));
export var FlowRunExportFailureStage;
(function (FlowRunExportFailureStage) {
    FlowRunExportFailureStage["MarkProcessing"] = "MarkProcessing";
    FlowRunExportFailureStage["GatherAndWrite"] = "GatherAndWrite";
    FlowRunExportFailureStage["MarkCompleted"] = "MarkCompleted";
    FlowRunExportFailureStage["WorkflowStart"] = "WorkflowStart";
})(FlowRunExportFailureStage || (FlowRunExportFailureStage = {}));
export var DescendantRunsCompleteness;
(function (DescendantRunsCompleteness) {
    DescendantRunsCompleteness["Full"] = "Full";
    DescendantRunsCompleteness["TruncatedByCount"] = "TruncatedByCount";
    DescendantRunsCompleteness["TruncatedByDepth"] = "TruncatedByDepth";
})(DescendantRunsCompleteness || (DescendantRunsCompleteness = {}));
export var FlowRunExportReadScope;
(function (FlowRunExportReadScope) {
    /** No column projection: read every block and walk the full descendant subtree. */
    FlowRunExportReadScope["All"] = "All";
    /** Column projection active: read only named blocks and descendants needed by selected subflows. */
    FlowRunExportReadScope["Projected"] = "Projected";
})(FlowRunExportReadScope || (FlowRunExportReadScope = {}));
export var SchemaCoercionKind;
(function (SchemaCoercionKind) {
    SchemaCoercionKind["LeafReceivedNonString"] = "LeafReceivedNonString";
    SchemaCoercionKind["ListReceivedNonArray"] = "ListReceivedNonArray";
    SchemaCoercionKind["StructReceivedNonStruct"] = "StructReceivedNonStruct";
    SchemaCoercionKind["ListElementNotStruct"] = "ListElementNotStruct";
    SchemaCoercionKind["UnknownColumnDropped"] = "UnknownColumnDropped";
})(SchemaCoercionKind || (SchemaCoercionKind = {}));
export var ExportAnomalyKind;
(function (ExportAnomalyKind) {
    ExportAnomalyKind["MissingParentBlockShell"] = "MissingParentBlockShell";
    ExportAnomalyKind["NullParentBlockId"] = "NullParentBlockId";
    ExportAnomalyKind["BlockNameCollision"] = "BlockNameCollision";
    ExportAnomalyKind["UnexpectedMultipleChildren"] = "UnexpectedMultipleChildren";
})(ExportAnomalyKind || (ExportAnomalyKind = {}));
//# sourceMappingURL=exportWorkflow.js.map